const cropManagementEn = {
    cropStageMaster: require('../../lang/en/crop_management/CropStageMaster').default,
    cropScheduleVariant: require('../../lang/en/crop_management/CropScheduleVariant').default,
    dayWiseSchedule: require('../../lang/en/crop_management/DayWiseSchedule').default,
};

export default cropManagementEn;
